import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    flexDirection: 'column',
    padding: '0px 15px',
    width: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    alignItems: 'center'
  },
  herderTitle: { display: 'flex', flexDirection: 'column', gap: 6 },
  greyText: { fontWeight: 600, color: theme.palette.grey[600] },
  whiteText: { color: theme.palette.primary.contrastText, fontWeight: 600 },
  pmsEvent: { display: 'flex' },
  icon: { fontSize: 30 },
  startIcon: { fontsize: 18, color: theme.palette.grey[600] },
  basicDetails: {
    display: 'grid',
    gridTemplateColumns: '4fr 1.15fr',
    gap: theme.spacing(2),
    margin: '8px 0',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr '
    }
  },
  right: { height: '100%' },
  left: { height: '100%', display: 'flex', flexDirection: 'column', flex: 1 },
  lastChangerSourceInfo: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    margin: '8px 0',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr '
    }
  },
  btn: { background: theme.palette.grey[200], boxShadow: 'none' },
  moreIcon: { fontSize: 20, background: theme.palette.grey[200] },
  moreIconbtn: {
    background: theme.palette.grey[200],
    borderRadius: 0,
    marginLeft: 6
  },
  divider: { marginTop: 8, marginBottom: 8 },
  btnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  button: { width: '10%', margin: '0  0 0 16px', height: '32px' },
  btnText: { color: theme.palette.primary.contrastText, fontWeight: 500 },
  confirmBtn: { marginRight: 16, boxShadow: 'none' },
  headerTitle: { color: theme.palette.text.primary },
  error: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 6,
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.primary.light,
    padding: theme.spacing(1.5),
    margin: '8px 0'
  },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    fontSize: 12,
    color: theme.palette.primary.main
  }
}))
export default useStyles
